import { render, staticRenderFns } from "./ldtd.vue?vue&type=template&id=dc143096&scoped=true"
import script from "./ldtd.vue?vue&type=script&lang=js"
export * from "./ldtd.vue?vue&type=script&lang=js"
import style0 from "./ldtd.vue?vue&type=style&index=0&id=dc143096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc143096",
  null
  
)

export default component.exports